<aecom-form columns="12" class="contentcontainer">
  <aecom-form-item class="itemBlock" [label]="'Issued By'" columnSpan="6">
    <div class="itemText">{{ rfiDetail.originator }}</div>
  </aecom-form-item>

  <aecom-form-item class="itemBlock" [label]="'Issue Date'" columnSpan="6">
    <div class="itemText">{{ rfiDetail.issuedDate }}</div>
  </aecom-form-item>

  <aecom-form-item class="itemBlock" [label]="'Responded By'" columnSpan="6">
    <div class="itemText">{{ rfiDetail.responder?.displayName || 'N/A'}}</div>
  </aecom-form-item>

  <aecom-form-item class="itemBlock" [label]="'Response Date'" columnSpan="6">
    <div class="itemText">{{ rfiDetail.respondedDate || 'N/A'}}</div>
  </aecom-form-item>

  <aecom-form-item class="itemBlock" [label]="'Title'" columnSpan="12">
    @if (rfiDetail.title) {
      <div class="itemText">{{ rfiDetail.title }}</div>
    } @else {
      <div class="itemText">N/A</div>
    }
  </aecom-form-item>

  <aecom-form-item class="itemBlock" [label]="'Question'" columnSpan="12">
    @if (rfiDetail.question) {
      <div class="itemText" [innerHtml]="rfiDetail.question">
      </div>
    } @else {
      <div class="itemText">N/A</div>
    }
  </aecom-form-item>

  <aecom-form-item class="itemBlock" [label]="'Proposed Solution'" columnSpan="12">
    @if (rfiDetail.proposedSolution) {
      <div class="itemText" [innerHtml]="rfiDetail.proposedSolution">
      </div>
    } @else {
      <div class="itemText">N/A</div>
    }
  </aecom-form-item>

  <aecom-form-item class="itemBlock" [label]="'Anticipated Next Step'" columnSpan="12">
    @if (rfiDetail.anticipatedNextStep) {
      <div class="itemText" [innerHtml]="rfiDetail.anticipatedNextStep">
      </div>
    } @else {
      <div class="itemText">N/A</div>
    }
  </aecom-form-item>

  <aecom-form-item columnSpan="6">
    <bbj-file-list
      title="Attachments"
      [fileList]="docFiles"
      [allowMovingFiles]="false"
    ></bbj-file-list>
  </aecom-form-item>

  <aecom-form-item class="itemBlock" columnSpan="6"></aecom-form-item>

  <aecom-form-group columnSpan="12" columns="2" title="Metadata" class="marginTop">
    <aecom-form-item class="itemBlock" [label]="'Phase'" columnSpan="1">
      @if (rfiDetail.phase) {
        <div class="itemText">{{ rfiDetail.phase}}</div>
      } @else {
        <div class="itemText">N/A</div>
      }
    </aecom-form-item>

    <aecom-form-item class="itemBlock" [label]="'Classification'" columnSpan="1">
      @if (rfiDetail.classification) {
        <div class="itemText">{{ rfiDetail.classification}}</div>
      } @else {
        <div class="itemText">N/A</div>
      }
    </aecom-form-item>

    <aecom-form-item class="itemBlock" [label]="'Drawing and Detail Ref'" columnSpan="1">
      @if (rfiDetail.drawingAndDetailRef) {
        <div class="itemText">{{ rfiDetail.drawingAndDetailRef}}</div>
      } @else {
        <div class="itemText">N/A</div>
      }
    </aecom-form-item>

    <aecom-form-item class="itemBlock" [label]="'Contract Requirements'" columnSpan="1">
      @if (rfiDetail.contractRequirement) {
        <div class="itemText">{{ rfiDetail.contractRequirement }}</div>
      } @else {
        <div class="itemText">N/A</div>
      }
    </aecom-form-item>

    <aecom-form-item class="itemBlock" [label]="'UniFormat Level 1 Category'" columnSpan="1">
      @if (rfiDetail.division) {
        <div class="itemText">{{ rfiDetail.division }}</div>
      } @else {
        <div class="itemText">N/A</div>
      }
    </aecom-form-item>

    <aecom-form-item class="itemBlock" [label]="'UniFormat Level 2 Category'" columnSpan="1">
      @if (rfiDetail.specification) {
        <div class="itemText">{{ rfiDetail.specification }}</div>
      } @else {
        <div class="itemText">N/A</div>
      }
    </aecom-form-item>

    <!-- <aecom-form-item class="itemBlock" [label]="'MasterFormat Specification Section'" columnSpan="1">
    <div class="itemText">{{ rfiDetail.masterSpec }}</div>
  </aecom-form-item> -->

  <aecom-form-item class="itemBlock" [label]="'Anticipated Schedule Impact'" columnSpan="1">
    @if (rfiDetail.anticipatedScheduleImpact) {
      <div class="itemText">{{ rfiDetail.anticipatedScheduleImpact }}</div>
    } @else {
      <div class="itemText">N/A</div>
    }
  </aecom-form-item>

  <aecom-form-item class="itemBlock" [label]="'Anticipated Cost Impact'" columnSpan="1">
    @if (rfiDetail.anticipatedCostImpact) {
      <div class="itemText">{{ rfiDetail.anticipatedCostImpact  }}</div>
    } @else {
      <div class="itemText">N/A</div>
    }
  </aecom-form-item>

  <aecom-form-item class="itemBlock" [label]="'Schedule Impact Details'" columnSpan="1">
    @if (rfiDetail.scheduleImpactDetails) {
      <div class="itemText" [innerHtml]="rfiDetail.scheduleImpactDetails"></div>
    } @else {
      <div class="itemText">N/A</div>
    }
  </aecom-form-item>

  <aecom-form-item class="itemBlock" [label]="'Cost Impact Details'" columnSpan="1">
    @if (rfiDetail.costImpactDetails) {
      <div class="itemText" [innerHtml]="rfiDetail.costImpactDetails"></div>
    } @else {
      <div class="itemText">N/A</div>
    }
  </aecom-form-item>
</aecom-form-group>

<aecom-form-group columnSpan="12" columns="1" title="Additional Details">
  <aecom-form-item class="itemBlock" [label]="'Internal Reference Number'" columnSpan="1">
    @if (rfiDetail.contractorReference) {
      <div class="itemText">{{ rfiDetail.contractorReference }}</div>
    } @else {
      <div class="itemText">N/A</div>
    }
  </aecom-form-item>

  <aecom-form-item class="itemBlock" [label]="'Priority Note'" columnSpan="1">
    @if (rfiDetail.note) {
      <div class="itemText" [innerHtml]="rfiDetail.note"></div>
    } @else {
      <div class="itemText">N/A</div>
    }
  </aecom-form-item>

  <aecom-form-item class="itemBlock" [label]="'Processing Note'" columnSpan="1">
    @if (rfiDetail.processingNotes) {
      <div class="itemText" [innerHtml]="rfiDetail.processingNotes"></div>
    } @else {
      <div class="itemText">N/A</div>
    }
  </aecom-form-item>
</aecom-form-group>
</aecom-form>

